import Hero from "../Component/Hero";
import DownloadAppSection from "../../../Components/DownloadAppSection";
import PengajuanPinjaman from "../Component/PengajuanPinjaman";
import PersyaratanPinjaman from "../Component/PersyaratanPinjaman";
import React from "react";
import CardDokumenPendukung from "../Component/CardDokumenPendukung";
import Table from "../Component/Table";

function Kasbon() {
    return (
        <>
            <div>
                <Hero
                    imageClass='kasbon'
                    title='Kasbon <em>(Emergency Loan)</em>'
                    subTitle='P I N J A M A N &emsp;I N D I V I D U'
                    explanation='
                        Kasbon adalah fasilitas pinjaman untuk kebutuhan darurat yang memberi kemudahan bagi karyawan seperti pembayaran gaji di muka <em>(salary advance).</em>
                        <br/><br/>
                        Fasilitas ini tidak dikenakan bunga, Danai.id hanya mengenakan biaya adminstrasi yang terjangkau.'
                    buttonText='AJUKAN PINJAMAN'
                />
                <Table type='individu' title='kasbon'/>
                <PersyaratanPinjaman type='individu' product='kasbon'/>
                <CardDokumenPendukung type='individu' product='kasbon'/>
                <PengajuanPinjaman type='individu'/>
                <DownloadAppSection/>
            </div>
        </>
    );
}

export default Kasbon;
